import React, { FC, useEffect } from 'react'
import { AnimatePresence } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import { FloatingCtaButton } from '@/views/PreSales/PreSalesGiveawayView/components/UI/FloatingCtaButton'
import { FloatingShareButton } from '@/views/PreSales/PreSalesGiveawayView/components/UI/FloatingShareButton'
import { useGiveawayContext } from '../../context/GiveawayContext'

export const FloatingButtons: FC = () => {
  const { isActive, setIsShareModalOpen, scrollToProducts, giveawayData, heroContainerRef, mobileTicketContainerRef } =
    useGiveawayContext()

  const { ref: heroObserverRef, inView: isHeroInView } = useInView({
    threshold: 0.5,
    triggerOnce: false,
  })
  const { ref: mobileProductsObserverRef, inView: isMobileProductsInView } = useInView({
    threshold: 0,
    triggerOnce: false,
  })
  const { share } = giveawayData

  useEffect(() => {
    if (heroContainerRef.current) {
      heroObserverRef(heroContainerRef.current)
    }
  }, [heroContainerRef, heroObserverRef])

  useEffect(() => {
    if (mobileTicketContainerRef.current) {
      mobileProductsObserverRef(mobileTicketContainerRef.current)
    }
  }, [mobileTicketContainerRef, mobileProductsObserverRef])

  if (!isActive) return null

  return (
    <AnimatePresence>
      <>
        {!isHeroInView && share && (
          <FloatingShareButton
            onClick={() => setIsShareModalOpen(true)}
            className={!isMobileProductsInView ? 'bottom-24 md:bottom-[1.5rem]' : 'bottom-[1.5rem]'}
          />
        )}

        {!isHeroInView && !isMobileProductsInView && <FloatingCtaButton onClick={scrollToProducts} />}
      </>
    </AnimatePresence>
  )
}
